export default __webpack_public_path__ + "static/gumgum-0258d8bee293229c71e9ccbd0dc14e02.svg";